<template>
  <div class="modal-content">
    <div class="modal-header">
      <button @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
              style="width: 30px; height: 30px; border-radius: 30px; font-size: 30px; background: gray;"><span
        aria-hidden="true">×</span></button>
      <h4 v-html="$t('popup_password.weak_password.header')"
          class="title-coupons"></h4>
      <div class="free-menu-description section-content--free-menu t13 text-black">
        {{$t('popup_password.weak_password.info')}}
      </div>
      <hr />
      <form @submit="checkForm" action="" method="post" novalidate="true">
        <div class="form-field">
          <div class="xs-flex xs-items-center xs-mb-5">
            <label class="label label-input xs-mb-0" for="old_password">{{$t('popup_password.your_current_password')}}<span class="cl-red">{{ $t('required') }}</span></label>
            <span v-if="errors.old_password" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
              <span>{{ errors.old_password }}</span>
            </span>
          </div>
          <input id="old_password" ref="old_password" class="input xs-mb-10 check-validate"
                 v-bind:class="{ 'has-errors': errors.old_password , 'has-success': errors.old_password === false}"
                 name="old_password" v-model="old_password" value="" type="password" autocomplete="password">
        </div>
        <div class="form-field">
          <div class="xs-flex xs-items-center xs-mb-5">
            <label class="label label-input xs-mb-0" for="password">{{$t('popup_password.new_password')}}<span class="cl-red">{{ $t('required') }}</span></label>
            <span v-if="errors.password" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
              <span>{{ errors.password }}</span><i class="icon-error"></i>
            </span>
          </div>
          <div class="xs-flex xs-items-center xs-mb-10 input-password check-validate"
               v-bind:class="{ 'has-errors': errors.password , 'has-success': errors.password === false}">
            <input id="password" ref="password" class="form-control input input-phone-border" :minlength=8
                   :type="showPass ? 'text' : 'password'" v-model="password"
                   name="password" value="" autocomplete="password" />
            <span class="show-password-prefix" @click="showPassword">
                <i class="fa" v-bind:class="{'fa-eye-slash': !showPass, 'fa-eye': showPass}" />
              </span>
            <span class="input-prefix" @click="generatePassword">{{$t('generate')}}</span>
          </div>
          <div class="xs-flex xs-items-center xs-mb-5">
            <span class="text-alert">{{$t('register.password_condition')}}</span>
          </div>
          <div class="xs-flex xs-items-center xs-mb-5" v-for="passwordValid in passwordValidation">
            <i class="fa" v-bind:class="{ 'fa-times xs-text-red': (passwordValid.status === 0), 'fa-check xs-text-green-dark': (passwordValid.status === 1), 'fa-times xs-text-gray': (passwordValid.status === 2)}"
               v-bind:key="passwordValid.message" />
            <div class="typo-l7"
                 v-bind:class="{ 'xs-text-red': (passwordValid.status === 0), 'xs-text-green-dark': (passwordValid.status === 1), 'xs-text-gray': (passwordValid.status === 2)}"
                 v-bind:key="passwordValid.message">
              <span>{{passwordValid.message}}</span>
            </div>
          </div>
          <div class="xs-flex xs-items-center xs-mb-5">
            <span class="text-alert">{{$t('register.password_condition_infomation')}}</span>
          </div>
        </div>
        <div class="form-field">
          <input type="submit" class="button button--primary" v-bind:value="$t('popup_password.btn_use_password')">
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import constant from '../../constants'

  export default {
    components: {
      Vue
    },
    watch: {
      password: function (newValue) {
        const validationResult = []
        let count = 0;
        this.passwordValidation = this.passwordValidation.map(rule=> {
          if (rule.regex.test(newValue)) {
            rule.status = 1
            validationResult.push(rule.status)
            count++
          } else {
            rule.status = 0
            validationResult.push(rule.status)
          }

          return rule
        })

        this.passwordValidation.forEach(function(item) {
          if (!item.status && count === 3) {
            item.status = 2;
          }
        })

        this.errors.password = (validationResult.length < 3 || newValue.length < constant.PASSWORD_MIN) ? '' : false;
      },
      old_password: function (newValue) {
        if (!newValue) {
          this.errors.old_password = this.$t('required_display')
        } else {
          this.errors.old_password = false
        }
      }
    },
    data() {
      return {
        old_password: '',
        password: '',
        showPass: 0,
        errors: {
          'old_password': '',
          'password': ''
        },
        passwordValidation: []
      }
    },
    mounted() {
      this.passwordValidation = [
        {
          status: 0,
          message: this.$t('validate_password_no_uppercase'),
          regex: /[A-Z]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_lowercase'),
          regex: /[a-z]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_number'),
          regex: /[0-9]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_non_alphanumberic'),
          regex: /[^a-zA-Z\d\s:]/
        }
      ]
      let formInfo = {
        id: 'submit-pass-form',
        name: 'submit-pass-form',
        category: 'pass-form',
        url: window.location.href
      }
      this.eventTrackingFormLoad(formInfo)
    },
    methods: {
      showPassword: function() {
        this.showPass = !this.showPass
      },
      generatePassword: function () {
        this.password = Math.random().toString(36).slice(-8);
        for (let i = 0, n = constant.CHARSET_RULE.length; i < constant.PASSWORD_MIN; ++i) {
          this.password += constant.CHARSET_RULE.charAt(Math.floor(Math.random() * n));
        }
        this.showPass = true
      },
      checkForm: function (e) {
        e.preventDefault()
        let flag = false

        this.errors = {
          'old_password': '',
          'password': ''
        }

        let countCondition = 0;
        for (let i = 0; i < this.passwordValidation.length; i++) {
          if(this.passwordValidation[i].status) {
            countCondition++
          }
        }
        if (!this.password) {
          this.errors.password = this.$t('required_display')
          if (!flag) {
            this.$refs.password.focus()
          }
          flag = true
        } else if (countCondition < 3) {
          this.errors.password = this.$t('wrong_format')
          if (!flag) {
            this.$refs.password.focus()
          }
          flag = true
        } else if (this.password.length < constant.PASSWORD_MIN) {
          if (!flag) {
            this.$refs.password.focus()
          }
          this.errors.password = this.$t('validate_invalid_password')
          flag = true
        } else {
          this.errors.password = false
        }

        if (!this.old_password) {
          this.errors.old_password = this.$t('required_display')
          if (!flag) {
            this.$refs.old_password.focus()
          }
          flag = true
        } else {
          this.errors.old_password = false
        }

        if (flag) {
          return false
        }
        this.submit_pass()
      },
      submit_pass() {
        let vm = this
        let data = {
          "old_password": this.old_password,
          "password": this.password
        }
        this.eventTrackingFormSubmit({id: 'submit-pass-form'})
        this.axios.apiCustomer.updatePassword(data, (response) => {
          this.eventTrackingFormSuccess({id: 'submit-pass-form'})
          let info = {client: 1, email: data.email, password: data.password}
          this.$emit('close')
        }, function (error) {
          error = error.error
          let formInfo = {
            id: 'submit-pass-form',
            'error': {
              'code': error.code,
              'type': 'validation',
              'error': error.message
            }
          }
          vm.eventTrackingFormError(formInfo)
        })
      }
    }
  }
</script>
<style scoped>
  .form-field {
    margin-top: 10px;
  }
  .title-coupons {
    font-family: opensans;
    src: url(../../assets/fonts/open-sans/OpenSans-Bold.ttf);
    color: #C8102E;
    text-transform: uppercase;
    font-size: 20px;
    margin-bottom: 2px;
  }
  .has-errors {
    border: 1px solid #da291c !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalUpdatePassword.vue